<template lang="html">
  <div class="main">
    <!-- <div class="back">
      <span>

      </span>
    </div> -->
    <div class="title">
      <span @click="show='a'" class="rule" :class="show">用户协议</span>
      <span @click="show='b'" class="statement" :class="show" >隐私申明</span>
    </div>
    <div class="content" v-if="show==='a'">
      <h1>Cydex Express用户协议</h1>
      <h2>总则</h2>
      <ol>
        <li class="li">Cydex Express（以下简称Cydex）是瞬已网络科技（上海）有限公司（以下简称“瞬已”）提供的一项互联网文件传输服务，
          其网址是 www.cydex.cn。 本协议最后修订于2017年12月8日</li>
        <li class="li">用户应当同意本协议的条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击”同意"按钮即表示用户与瞬已达成协议，完全接受本协议项下的全部条款。</li>
        <li class="li">用户应当同意本协议的条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击”同意"按钮即表示用户与瞬已达成协议，完全接受本协议项下的全部条款。</li>
      </ol>
      <p>您在使用本服务之前，应仔细阅读本服务协议。如您不同意本服务协议及/或随时对其的修改，您可以主动取消瞬已提供的服务；您一旦使用瞬已提供的服务，即视为您已了解并完全同意本服务协议各项内容，包括瞬已对服务协议随时所做的任何修改，并成为Cydex用户。</p>
      <h2>注册信息和隐私保护</h2>
      <ol>
        <li>Cydex帐号的所有权归瞬已，用户完成注册申请手续后，获得Cydex帐号的使用权。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题，并对问题发生所带来的后果，瞬已不负任何责任。</li>
        <li>用户不应将其帐号、密码转让或出借予他人使用。如用户发现其帐号遭他人非法使用，应立即通知瞬已。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，瞬已不承担任何责任。</li>
        <li>
          瞬已不对外公开或向第三方提供单个用户的注册资料，除非：
          <ul>
            <li>事先获得用户的明确授权；</li>
            <li>只有透露你的个人资料，才能提供你所要求的产品和服务；</li>
            <li>根据有关的法律法规要求；</li>
            <li>按照相关政府主管部门的要求；</li>
            <li>为维护瞬已的合法权益。</li>
          </ul>
        </li>
      </ol>
      <h2>服务内容和使用规则</h2>
      <ol>
        <li>本服务是一个文件传输的SaaS（软件即服务），通过本服务，可以将您的超大（超多）文件安全传送给您期望的接收人。</li>
        <li>
          用户在使用本服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，不得上载或传播含有下列内容之一的文件或信息：
          <ul>
            <li>反对宪法所确定的基本原则的；</li>
            <li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
            <li>损害国家荣誉和利益的；</li>
            <li>煽动民族仇恨、民族歧视、破坏民族团结的；</li>
            <li>破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
            <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
            <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
            <li>侮辱或者诽谤他人，侵害他人合法权利的；</li>
            <li>含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</li>
            <li>侵犯他们合法知识产权的内容；</li>
            <li>含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。</li>
          </ul>
        </li>
        <li>用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿瞬已与合作公司、关联公司，
          并使之免受损害。对此，瞬已有权视用户的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、回收瞬已帐号、追究法律
          责任等措施。对恶意注册Cydex帐号或利用Cydx帐号进行违法活动、捣乱、骚扰、欺骗、其他用户以及其他违反本协议的行为，瞬已有权回收其帐号。同时，瞬已公司
          会视司法部门的要求，协助调查。</li>
        <li>
          用户须对自己在使用本服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在瞬已公司首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予瞬已公司等额的赔偿。
        </li>
        <li>
          为使用本服务，您必须能够自行经有法律资格对您提供互联网接入服务的第三方，进入国际互联网，并应自行支付相关服务费用。此外，您必须自行配备及负责与国际联网连线所需之一切必要装备，包括计算机、智能手机，平板电脑及足够的存储设备。
        </li>
        <li>
          本服务是一项收费服务，当用户使用量超过购买的额度时，瞬已有权暂停该账号全部或部分的功能，由此带来的损失，瞬已不承担责任。
        </li>
        <li>
          用户同意，您本地互联网接入的质量（带宽，丢包，延时等），会直接影响传输的速度，因此本服务并不承诺每一次传输的速度。
        </li>
        <li>
          瞬已有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，瞬已对用户和任何第三人均无需承担任何责任。
        </li>
      </ol>
      <h2>知识产权</h2>
      <ol>
        <li>严禁对本服务实施拷贝，模仿，及对本服务中使用的软件实施反向工程等侵权行为。一经发现，瞬已公司将诉诸法律。</li>
        <li>用户通过本服务传输和存储的所有内容，瞬已公司无任何权利复制，保留其他副本，或挪做其他商业用途。</li>
        <li>用户传输的内容涉及侵犯他人知识产权的，用户须自己承担法律责任，与瞬已公司无关。</li>
      </ol>
      <h2>限制责任</h2>
      <p>在适用法律允许的最大范围内，对于因使用本服务而发生的任何损害赔偿(包括但不限于业务利润损失、 业务中断、业务资料损失或其他金钱损失的损害赔偿)，瞬已公司及其供应商概不负责，
        即使瞬已公司已被通知有发生该等损害赔偿的可能性。在任何情况下, 瞬已在本协议任何条款项下的全部责任限于您就本服务实际支付的金额。上述限制不适用于适用法律规定不得予 以排除或限
        制的任何责任。
      </p>
      <h2>其他</h2>
      <ol>
        <li>本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</li>
        <li>如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向瞬已所在地的人民法院提起诉讼。</li>
        <li>瞬已未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。</li>
        <li>如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</li>
      </ol>
      <p>我们可能对本协议进行不定时的修订。我们会在本页面或其他我们认为合适的方式（包括向您发送电子邮件或以其他方式通知您）发布对本协议所做的任何变更，若您继续使用我们的服务，即表示您同意受修订后的协议的约束。如您对此有任何疑问，欢迎访问我们的网站 <a target="_blank" href="https://www.cydex.cn">www.cydex.cn</a> 提交反馈或致电 ＋86 21 50395100</p>
    </div>
    <div class="content" v-if="show==='b'">
      <h1>Cydex Express文件传输服务隐私保护申明</h1>
      <h2>我们可能收集的信息</h2>
      <ol>
        <li>您注册Cydex账号时，会向我们提供电子邮箱，并创建密码。还可能会提供手机号码，公司信息和个人照片。</li>
        <li>如果您通过我们网站申请开具发票，会向我们提供公司详细开票信息。</li>
        <li>在您使用我们的服务过程中，我们会收集您正在使用的设备信息，日志信息。</li>
        <li>您使用我们服务传输的文件，会根据您自己的设置期限，短期暂存在我们这里。</li>
      </ol>
      <h2>我们可能如何使用您的信息</h2>
      <p>我们基于以下目的收集您的信息。</p>
      <ol>
        <li>保障合法权益：我们需要在您注册和使用中，验证您的身份或您组织的真实性。以防止您的重要文件被不法分子侵入。</li>
        <li>提升用户体验。我们需要在您传输文件的关键节点向您发出通知，让您掌握进展；让您可以在移动设备上随时监视PC上传输的进展。</li>
        <li>提供个性化的服务。</li>
        <li>处理您的订单或财务事宜：涉及财务相关的操作，我们要确保您的信息真实并且操作出于您真实的意愿。</li>
        <li>持续改善我们的服务：我们根据日志信息和您主动反馈的其他信息，来持续改进我们的网站和服务。</li>
      </ol>
      <h2>我们如何保护您的隐私</h2>
      <ol>
        <li>我们使用SSL保护您通过浏览器与我们网站的所有数据交互。</li>
        <li>您的敏感信息，如密码，付款信息等，将会加密保存。</li>
        <li>您传输的任一个文件都经过AES 256的加密处理，在我们短期的存储期间，也保持加密，并分片保存。在到期后立即删除。</li>
      </ol>
      <h2>我们是否使用cookies</h2>
      <p>是的，Cookie是一些小文件，网站通过浏览器给您发送并存储在您硬盘上，用于下一次使用时，记住您上次使用的一些特定信息。我们使用Cookie技术来理解和保存您的喜好，以提升您访问我们网站时的体验。</p>
      <h2>我们是否向第三方泄漏您的个人信息</h2>
      <p>我们承诺不会将您的个人身份信息泄漏给外部第三方。除非这个第三方是受信任的，需要这些信息来帮助我们提升服务，并且同样承诺对这些信息保密。但如果您传输的内容涉嫌违反了中华人民共和国的法律法规，我们依法有权提供您的个人信息协助调查。</p>
      <h2>未成年人使用</h2>
      <p>若您是18周岁以下的未成年人，建议您请您的监护人仔细阅读本隐私政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。</p>
      <h2>隐私政策的修订</h2>
      <p>我们可能对本隐私政策进行不定时的修订。我们会在本页面或其他我们认为合适的方式（包括向您发送电子邮件或以其他方式通知您）发布对本隐私政策所做的任何变更，若您继续使用我们的服务，即表示您同意受修订后的本隐私政策的约束。</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: 'a'
    }
  },
  mounted () {
    if (this.$route.query.value === 'copyright') {
      this.show = 'a'
    }
    if (this.$route.query.value === 'statement') {
      this.show = 'b'
    }
  }
}
</script>

<style lang="css" scoped>
  .main {
    position: relative;
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
  }
  .content {
    width: 100%;
    line-height: 2;
    padding-left: 120px;
    padding-bottom: 60px;
  }
  .title {
    position: absolute;
    padding-top: 60px;
    top: 0;
    left: 0;
  }
  .title span {
    cursor: pointer;
    font-size: 16px;
    display: inline-block;
    width: 100%;
    margin-bottom: 20px;
  }
  .rule.a,
  .statement.b {
    font-weight: 600;
  }
  .back {
    width: 100%;
    height: 60px;
  }
  @media (max-width: 650px) {
    .title {
      position: fixed;
      background-color: #fff;
      border-bottom: 1px solid #999;
      width: 100%;
      padding: 0;
    }
    .title span {
      text-align: center;
      margin: 0;
      line-height: 60px;
      float: left;
      width: 50%;
    }
    .content {
      padding: 40px 20px 20px 20px;
    }
  }
</style>
